<div rrsInternalLink>
  <div #cmsTarget></div>
</div>
